export default __webpack_public_path__ + "static/media/ts-common.de8395a9.svg";